<!-- <h1 class="border border-2 bg-success p-5" style="display: inline-block;" cdkDrag>this my home page!</h1>

<div class="example-box" cdkDrag>
  Drag me around
</div>
-->

<div class="container-home-cards">

  <div class="card-home" routerLink="/insertion-point" (click)="settingsService.selectedMenu = 'insertionPoint';">
    <mat-icon class="home-cards__icon" style=" vertical-align: middle;" aria-hidden="false">gps_fixed</mat-icon>
    <div class="home-cards__text">Select Location for New Notes</div>
  </div>

  <div class="card-home" routerLink="/notebooks" (click)="settingsService.selectedMenu = 'notebooks';">
    <mat-icon class="home-cards__icon" style=" vertical-align: middle;" aria-hidden="false">library_books</mat-icon>
    <div class="home-cards__text">Notebooks</div>
  </div>

  <div class="card-home" routerLink="/reviews" (click)="settingsService.selectedMenu = 'reviews'; settingsService.reviewsTabActive = true" *ngIf="!isChromeExtension() || true">
    <mat-icon class="home-cards__icon" style=" vertical-align: middle;" aria-hidden="false">restore</mat-icon>
    <div class="home-cards__text">Reviews</div>
  </div>

  <div class="card-home" routerLink="/settings" (click)="settingsService.selectedMenu = 'settings';">
    <mat-icon class="home-cards__icon" style=" vertical-align: middle;" aria-hidden="false">settings</mat-icon>
    <div class="home-cards__text">Settings</div>
  </div>

  <a href="https://internalizeit.com/docs/" target="_blank" style="text-decoration: none; color: inherit;">
    <div class="card-home">
      <mat-icon class="home-cards__icon" style=" vertical-align: middle;" aria-hidden="false">help</mat-icon>
      <div class="home-cards__text">Documentation</div>
    </div>
  </a>

  <a href="https://internalizeit.com/feedback/" target="_blank" style="text-decoration: none; color: inherit;">
    <div class="card-home">
      <mat-icon class="home-cards__icon" style=" vertical-align: middle;" aria-hidden="false">feedback</mat-icon>
      <div class="home-cards__text">Send Your Feedback</div>
    </div>
  </a>

</div>
